"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateUF = void 0;
exports.validateUF = function () {
  var regex = /^(?:ac|al|ap|am|ba|ce|df|es|go|ma|mt|ms|mg|pa|pb|pr|pe|pi|rj|rn|rs|ro|rr|sc|sp|se|to)$/i;
  return function (uf) {
    return typeof uf === 'string' && regex.test(uf);
  };
}();